import { render, staticRenderFns } from "./LoadingModal.vue?vue&type=template&id=ca2ee944"
import script from "./LoadingModal.vue?vue&type=script&lang=js"
export * from "./LoadingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports